export default "__VITE_ASSET__BMU3XnTV__"